import React, { ComponentPropsWithoutRef } from 'react';

import { Container } from './styles';

interface Props extends ComponentPropsWithoutRef<'input'> {
  onlyNumber?: boolean;
}

function isNumber(event: React.KeyboardEvent<HTMLInputElement>): boolean {
  const { key } = event;
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'Tab' ||
    key === 'Escape' ||
    key === 'Enter' ||
    key.startsWith('Arrow')
  ) {
    return true;
  }

  // Allow: 0-9
  if (/^[0-9]$/.test(key)) {
    return true;
  }

  // Prevent anything else
  return false;
}

function handleKeyDown(
  onlyNumber: boolean,
  event: React.KeyboardEvent<HTMLInputElement>
) {
  if (onlyNumber && !isNumber(event)) {
    event.preventDefault();
  }
}

const Input: React.FC<Props> = ({ onlyNumber, ...rest }) => {
  return (
    <Container
      onKeyDown={(event) => handleKeyDown(onlyNumber, event)}
      {...rest}
    />
  );
};

export default Input;
